export default __webpack_public_path__ + "static/Averta-Regular-a0b1f1c67d63292e5cc1c0712ca2163f.woff2";